import { AppUnauthLayout, Logo } from '@/components'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_unauthRoutes')({
  component: RouteComponent,
})

function RouteComponent() {
  return <AppUnauthLayout logo={<Logo />} />
}
